<template>
    <BuilderBase :loading="datasetStore.loading">
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1">
                    <span class="steps">{{$t('common.step_1')}} 3<span class="slash">/</span>3:</span> <span class="title" >{{$t('views.dataset_payment_failed.title_short')}}</span>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <ToggleSimple :toggleable="false" :default="true" cssClass="toggle-type-2 important-title">
                <template #toggle>
                    <div class="left">
                        <div class="toggle-text">
                            {{ $t('views.dataset_payment_failed.title') }}
                        </div>
                        <div class="toggle-description">{{ $t('views.dataset_payment_failed.description')}}</div>
                    </div>
                </template>

                <template #content>
                    <div class="builder-checkout-type-1">
                        <OrderForm @form_submission_successful="proceedToCheckout()" />
                    </div>
                </template>
            </ToggleSimple>
        </template>
    </BuilderBase>
</template>

<script>
    import router from '@/router';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import OrderForm from '@/components/forms/DatasetOrderForm';
    import BuilderBase from '@/views/builder/BuilderBase';
    import { formatNumber } from '@/utils/formatting';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import { gaBuilderPayment } from '@/utils/analytics/builder';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            OrderForm,
            BuilderBase,
            ToggleSimple
        },
        props: {
            order_id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                seo_title: 'views.dataset_payment_failed.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            formatNumber,
            proceedToCheckout() {
                if(this.datasetStore.order?.checkout_url) {
                    window.location.href = this.datasetStore.order.checkout_url;
                } else {
                    router.push({ name: 'builder' });
                }
            },
        },
        async mounted() {

            if(this.order_id) {
                await this.datasetStore.fetchOrder(this.order_id);

                if(!this.datasetStore.order.status || !this.datasetStore.order.query) {
                    this.$router.push({ name: 'builder' });
                    return;
                } else if(this.datasetStore.order.status === 'paid') {
                    this.$router.push({ name: 'payment-success', query: { order_id: this.order_id } });
                    return;
                }

                if(!this.datasetStore.price || !this.datasetStore.query) {
                    const success = await this.datasetStore.fetchDataset(true);
                    if(!success || !this.datasetStore.count || !this.datasetStore.price || !this.datasetStore.query) {
                        this.$router.push({name: 'builder'});
                    }
                }

                gaBuilderPayment(false, this.datasetStore.order.count || null, this.datasetStore.order.price || null, this.order_id || null);
            } else {
                this.$router.push({ name: 'builder' });
            }
        }
    }
</script>